/**
 * STATE
 */

export const state = {
  user: {},
  isSuperAdmin: false,
  buckets: [],
  users: [],
  nodes: [],
  plans: {},
  apiUrl: process.env.API_URL,
  bucketCount: 0,
  enterpriseBucketCount: 0,
  snackbar: {
    type: 'success',
    text: '',
    isOpen: false
  },
  isNavigationDrawerOpened: false,
  purchaseOrders: [],
  bestDownloaders: [],
  docusignParams: null
}
